let routerInstance = void 0;
export default async ({ router }) => {
  routerInstance = router
}
export { routerInstance }
